import { SubHexMap } from '@/components/SubHexMap';

interface SubHexMapTabProps {
    hexId: number;
    isOwner: boolean;
}

export function SubHexMapTab({ hexId, isOwner }: SubHexMapTabProps) {
    return (
        <div className="max-w-6xl">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <h2 className="text-2xl font-bold text-white">The Map</h2>
                    <p className="text-gray-400 text-sm mt-1">
                        {isOwner
                            ? 'Paint your personal hex map. Select a tile from the palette and click to paint.'
                            : 'Explore this hex\'s personal map.'}
                    </p>
                </div>
            </div>
            <SubHexMap
                hexId={hexId}
                canEdit={isOwner}
            />
        </div>
    );
}
